import axios from 'axios';

/**
 * ProductsService
 */
export default class ProductsService
{
    public static path = 'admin/wk/trainings';

    /**
     * @param articleId number
     *
     * @returns Promise<ListItemModel[]>
     */
    public static async getListByArticleId(articleId: number): Promise<ListItemModel[]>
    {
        return (await axios.get<ListItemModel[]>(`${this.path}/by-article/${articleId}`)).data;
    }

    /**
     * @param search string
     * @param limit number
     * @param except number[]
     *
     * @returns Promise<string[]>
     */
    public static async getAutocomplete(search: string, limit: number = 10, except?: number[]): Promise<ListItemModel[]>
    {
        return (await axios.get<ListItemModel[]>(`${this.path}/autocomplete`, {
            params: {
                search: search,
                limit: limit,
                except: except
            }
        })).data;
    }

    /**
     * @param id number
     * @param except number[]
     *
     * @returns Promise<ListItemModel>
     */
    public static async fetchAutocomplete(id: number, except: number[] = []): Promise<ListItemModel>
    {
        return (await axios.get<ListItemModel>(`${this.path}/autocomplete/${id}`, {
            params: { except: except}
        })).data;
    }
}

export interface ListItemModel
{
    id: number;
    title: string;
}
